import { render, staticRenderFns } from "./itemList.vue?vue&type=template&id=f635bdbe&scoped=true&"
import script from "./itemList.vue?vue&type=script&lang=js&"
export * from "./itemList.vue?vue&type=script&lang=js&"
import style0 from "./itemList.vue?vue&type=style&index=0&id=f635bdbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f635bdbe",
  null
  
)

export default component.exports